import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import Link from 'components/consumer/Link';
import PDPMobileCarousel from 'components/consumer/PDP/PDPMobileCarousel';
import MobileModal from 'components/consumer/MobileModal';
import useIsBrowser from 'hooks/useIsBrowser';
import PDPDimensionsContent from '../PDPDimensionsContent';
const PDPMobileStudioCampaignLogo = loadable(() => import('./PDPMobileStudioCampaignLogo'));
const PDPMobileStudioPhotoGalleryUI = t0 => {
  const $ = _c(30);
  const {
    enableCrops: t1,
    introVideoId,
    linkTo,
    mode: t2,
    photos: t3,
    productName,
    viewGalleryImageEvent,
    campaign
  } = t0;
  const enableCrops = t1 === undefined ? true : t1;
  const mode = t2 === undefined ? "pdp" : t2;
  let t4;
  if ($[0] !== t3) {
    t4 = t3 === undefined ? [] : t3;
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const photos = t4;
  const isPdpMode = mode === "pdp";
  const isGalleryLinked = !isPdpMode && linkTo;
  const GalleryWrapper = isGalleryLinked ? Link : "div";
  const [isDimensionsModalOpen, setIsDimensionsModalOpen] = useState(false);
  const isBrowser = useIsBrowser();
  let t5;
  if ($[2] !== isGalleryLinked) {
    t5 = classNames("PDPMobileStudioPhotoGalleryUI", {
      "block mt-[5px]": isGalleryLinked
    });
    $[2] = isGalleryLinked;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const t6 = isGalleryLinked ? linkTo : null;
  let t7;
  if ($[4] !== campaign || $[5] !== isBrowser) {
    t7 = isBrowser ? <PDPMobileStudioCampaignLogo campaign={campaign} /> : null;
    $[4] = campaign;
    $[5] = isBrowser;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== photos || $[8] !== viewGalleryImageEvent) {
    t8 = idx => {
      const photo = photos[idx];
      if (photo) {
        viewGalleryImageEvent({
          imageLocation: "Hero Gallery",
          imageFilename: photo.src?.split("/").pop() || "",
          totalImages: photos.length,
          position: idx
        });
      }
    };
    $[7] = photos;
    $[8] = viewGalleryImageEvent;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== enableCrops || $[11] !== introVideoId || $[12] !== isPdpMode || $[13] !== photos || $[14] !== productName || $[15] !== t8) {
    t9 = <PDPMobileCarousel enableCrops={enableCrops} isHero={true} photos={photos} videoId={introVideoId} productName={productName} showFavoriteButton={isPdpMode} onAfterSlide={t8} displayShownIn={isPdpMode} showARIcon={true} zoomOnClick={isPdpMode} />;
    $[10] = enableCrops;
    $[11] = introVideoId;
    $[12] = isPdpMode;
    $[13] = photos;
    $[14] = productName;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== GalleryWrapper || $[18] !== t5 || $[19] !== t6 || $[20] !== t7 || $[21] !== t9) {
    t10 = <GalleryWrapper className={t5} to={t6}>{t7}{t9}</GalleryWrapper>;
    $[17] = GalleryWrapper;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  let t12;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => {
      setIsDimensionsModalOpen(false);
    };
    t12 = <PDPDimensionsContent />;
    $[23] = t11;
    $[24] = t12;
  } else {
    t11 = $[23];
    t12 = $[24];
  }
  let t13;
  if ($[25] !== isDimensionsModalOpen) {
    t13 = <MobileModal isOpen={isDimensionsModalOpen} title="Dimensions" isFullHeight={true} onClose={t11}>{t12}</MobileModal>;
    $[25] = isDimensionsModalOpen;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t10 || $[28] !== t13) {
    t14 = <>{t10}{t13}</>;
    $[27] = t10;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  return t14;
};
PDPMobileStudioPhotoGalleryUI.propTypes = {
  enableCrops: PropTypes.bool,
  introVideoId: PropTypes.string,
  linkTo: PropTypes.string,
  mode: PropTypes.oneOf(['pdp', 'quickview']),
  photos: PropTypes.arrayOf(PropTypes.object),
  productName: PropTypes.string,
  viewGalleryImageEvent: PropTypes.func,
  campaign: PropTypes.string
};
export default PDPMobileStudioPhotoGalleryUI;